import { useNavigate } from 'react-router-dom';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-[var(--tg-theme-text-color)] mb-1.5">{title}</h3>
      <div className="text-[13px] text-[var(--tg-theme-hint-color)] leading-relaxed space-y-1.5">
        {children}
      </div>
    </div>
  );
}

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="p-4 animate-fade-in max-w-2xl mx-auto pb-24">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)} className="tg-button text-sm flex items-center gap-1.5">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Назад
        </button>
      </div>

      <div className="tg-card p-4 space-y-5">
        <div>
          <h2 className="text-lg font-bold text-[var(--tg-theme-text-color)] mb-1">🔒 Политика конфиденциальности EduPulse</h2>
          <p className="text-[11px] text-[var(--tg-theme-hint-color)]">Дата последнего обновления: 19 августа 2026 года</p>
          <p className="text-[12px] text-[var(--tg-theme-hint-color)] leading-relaxed mt-2">
            Настоящая Политика конфиденциальности регулирует порядок сбора, обработки, хранения, использования и защиты персональных данных при использовании сервиса <strong>EduPulse</strong> — Telegram Mini App для преподавателей и образовательных организаций.
          </p>
          <p className="text-[12px] text-[var(--tg-theme-hint-color)] leading-relaxed">
            Используя EduPulse, пользователь подтверждает, что ознакомился с настоящей Политикой.
          </p>
        </div>

        <Section title="1. Оператор и контакты">
          <p>Сервис EduPulse предоставляется разработчиком/владельцем сервиса:</p>
          <p><strong>Наименование:</strong> [ФИО / ИП / ТОО / иная зарегистрированная форма]</p>
          <p><strong>Бренд:</strong> EduPulse</p>
          <p><strong>Страна:</strong> Республика Казахстан</p>
          <p><strong>Контакт:</strong> [актуальный Telegram / e-mail]</p>
        </Section>

        <Section title="2. Что такое EduPulse">
          <p>
            EduPulse — рабочий цифровой инструмент для преподавателей, репетиторов, кружков и небольших образовательных организаций.
          </p>
          <p>Сервис позволяет:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>вести сведения об учениках;</li>
            <li>управлять курсами и группами;</li>
            <li>планировать занятия;</li>
            <li>отмечать посещаемость;</li>
            <li>вести журнал платежей;</li>
            <li>создавать достижения и заметки;</li>
            <li>получать статистику;</li>
            <li>управлять командой образовательной организации;</li>
            <li>получать оперативные уведомления и задачи через раздел Inbox;</li>
            <li>управлять тарифом и подпиской.</li>
          </ul>
          <p>
            EduPulse не является образовательной организацией, школой или работодателем пользователя и не принимает решения за пользователя относительно его учеников.
          </p>
        </Section>

        <Section title="3. Какие данные мы обрабатываем">
          <h4 className="text-[12px] font-semibold text-[var(--tg-theme-text-color)]">3.1. Данные пользователя</h4>
          <p>При использовании EduPulse могут обрабатываться: Telegram ID, имя и фамилия, Telegram username, фотография профиля, роль в EduPulse, сведения об образовательной организации, часовой пояс, язык интерфейса, валюта, настройки приложения, сведения о тарифе и подписке.</p>

          <h4 className="text-[12px] font-semibold text-[var(--tg-theme-text-color)]">3.2. Данные, которые пользователь вводит самостоятельно</h4>
          <p>Пользователь может добавлять: учеников, родителей, курсы, группы, расписание, посещаемость, домашние задания, заметки, достижения, платежи.</p>

          <h4 className="text-[12px] font-semibold text-[var(--tg-theme-text-color)]">3.3. Данные учеников</h4>
          <p>
            В зависимости от использования сервиса могут вводиться: имя и фамилия, возраст/дата рождения, фотография, контактные данные родителя, телефон, принадлежность к курсам, посещаемость, достижения, заметки.
          </p>
          <p>
            Пользователь обязан иметь соответствующее правовое основание для передачи и обработки данных учеников и их законных представителей.
          </p>
        </Section>

        <Section title="4. Цели обработки данных">
          <p>Данные используются для:</p>
          <ol className="list-decimal pl-5 space-y-1">
            <li>идентификации и авторизации пользователя;</li>
            <li>предоставления функциональности EduPulse;</li>
            <li>управления учениками, курсами, группами и занятиями;</li>
            <li>ведения посещаемости;</li>
            <li>отображения и учёта платежей;</li>
            <li>предоставления статистики и аналитики;</li>
            <li>работы команд и разграничения доступа;</li>
            <li>предоставления и управления подпиской;</li>
            <li>обработки платежей через Telegram Stars;</li>
            <li>обеспечения безопасности;</li>
            <li>предотвращения злоупотреблений;</li>
            <li>технической поддержки;</li>
            <li>диагностики ошибок и улучшения стабильности;</li>
            <li>выполнения требований законодательства.</li>
          </ol>
          <p>Мы не продаём персональные данные пользователей рекламодателям.</p>
        </Section>

        <Section title="5. Правовые основания обработки">
          <p>Обработка может осуществляться на основании:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>согласия субъекта персональных данных;</li>
            <li>для исполнения договора или предоставления услуги;</li>
            <li>для выполнения обязанностей, предусмотренных законодательством;</li>
            <li>для защиты прав и законных интересов.</li>
          </ul>
          <p>
            Для пользователей из ЕС/ЕЭЗ могут применяться дополнительные основания GDPR.
          </p>
        </Section>

        <Section title="6. Персональные данные несовершеннолетних">
          <p>
            EduPulse предназначен для преподавателей, а не для самостоятельного использования детьми. При этом сервис может содержать данные несовершеннолетних учеников, внесённые преподавателем. Пользователь обязан иметь законное основание для их обработки и соблюдать требования законодательства.
          </p>
        </Section>

        <Section title="7. Платёжные данные">
          <p>
            Для оплаты используется Telegram Stars. EduPulse <strong>не получает и не хранит</strong> номер банковской карты, CVV/CVC, PIN или пароль банковского приложения.
          </p>
          <p>
            EduPulse может хранить технические сведения: идентификатор транзакции, приобретённый тариф, количество Stars, дату и время платежа, статус платежа.
          </p>
        </Section>

        <Section title="8. Поставщики инфраструктуры">
          <p>Для работы EduPulse могут использоваться сторонние поставщики:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Telegram — платформа Mini App и авторизация;</li>
            <li>PostgreSQL/Neon — база данных;</li>
            <li>хостинг-провайдер — размещение серверной части;</li>
            <li>иные технические поставщики.</li>
          </ul>
        </Section>

        <Section title="9. Хранение данных">
          <p>
            Основной базой данных EduPulse является PostgreSQL. Это особенно важно для пользователей из Казахстана, поскольку законодательство РК устанавливает требования к хранению персональных данных на территории Республики Казахстан.
          </p>
        </Section>

        <Section title="10. Срок хранения">
          <p>
            Персональные данные хранятся не дольше, чем необходимо для достижения целей обработки. После удаления аккаунта данные могут быть удалены, обезличены или сохранены только в той степени, в которой дальнейшее хранение необходимо по закону.
          </p>
        </Section>

        <Section title="11. Безопасность">
          <p>Для защиты данных применяются:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>HTTPS/TLS;</li>
            <li>проверка Telegram initData;</li>
            <li>HMAC-проверка данных Telegram;</li>
            <li>JWT-аутентификация;</li>
            <li>ограниченный срок действия токена;</li>
            <li>хранение JWT в памяти приложения;</li>
            <li>разграничение доступа;</li>
            <li>фильтрация данных по пользователю и организации;</li>
            <li>валидация входных данных;</li>
            <li>rate limiting;</li>
            <li>резервное копирование.</li>
          </ul>
        </Section>

        <Section title="12. Доступ к данным">
          <p>Доступ предоставляется в соответствии с ролью пользователя:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Индивидуальный преподаватель</strong> — доступ к собственным данным;</li>
            <li><strong>Владелец школы</strong> — доступ к данным своей организации;</li>
            <li><strong>Администратор</strong> — доступ в пределах назначенной роли;</li>
            <li><strong>Преподаватель школы</strong> — доступ только к предусмотренным функциям;</li>
            <li><strong>Системный владелец</strong> — технический доступ в объёме, необходимом для эксплуатации.</li>
          </ul>
        </Section>

        <Section title="13. Передача данных третьим лицам">
          <p>
            Мы не продаём персональные данные. Данные могут передаваться только в случаях, необходимых для работы инфраструктуры, обработки платежей, технической поддержки, обеспечения безопасности, исполнения закона.
          </p>
        </Section>

        <Section title="14. Трансграничная передача">
          <p>
            Поскольку EduPulse использует Telegram и облачную инфраструктуру, может возникать передача или доступ к данным из других государств. Такая передача должна осуществляться с соблюдением требований применимого законодательства.
          </p>
        </Section>

        <Section title="15. Права пользователя">
          <p>Пользователь может иметь право:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>получить информацию об обработке своих данных;</li>
            <li>получить доступ к своим данным;</li>
            <li>исправить неточные данные;</li>
            <li>потребовать удаления данных;</li>
            <li>ограничить обработку;</li>
            <li>отозвать согласие;</li>
            <li>получить копию данных;</li>
            <li>обратиться с жалобой в компетентный орган.</li>
          </ul>
        </Section>

        <Section title="16. Удаление аккаунта">
          <p>
            Пользователь может обратиться с запросом на удаление аккаунта и связанных с ним данных.
          </p>
          <p><strong>Telegram:</strong> [@username]<br /><strong>E-mail:</strong> [email]</p>
        </Section>

        <Section title="17. Изменение Политики">
          <p>
            Мы можем периодически обновлять настоящую Политику. Новая версия публикуется в EduPulse с указанием даты обновления. Если изменения существенно влияют на права пользователей, мы можем дополнительно уведомить пользователей.
          </p>
        </Section>

        <Section title="18. Контакты">
          <p><strong>EduPulse / [ФИО или юридическое лицо]</strong></p>
          <p><strong>Telegram:</strong> [@username]<br /><strong>E-mail:</strong> [email]</p>
        </Section>

        <p className="text-[11px] text-[var(--tg-theme-hint-color)] italic pt-2 border-t border-[var(--tg-theme-section-separator-color)]">
          Важно: настоящая Политика является пользовательским информационным документом и не заменяет юридическую консультацию. Перед коммерческим запуском необходимо проверить документ на соответствие фактической структуре владельца и требованиям законодательства.
        </p>
      </div>
    </div>
  );
}
